"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewBoxStarSize = exports.ReviewBoxType = exports.ReviewBoxFontSize = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Star_1 = require("../Icons/Star/Star");
var VerifiedReviewLabel_1 = __importStar(require("../Labels/VerifiedReviewLabel/VerifiedReviewLabel"));
var StarRatingGroup_1 = __importDefault(require("../StarRatingGroup/StarRatingGroup"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var ReviewBoxFontSize;
(function (ReviewBoxFontSize) {
    ReviewBoxFontSize["small"] = "small";
    ReviewBoxFontSize["default"] = "default";
})(ReviewBoxFontSize = exports.ReviewBoxFontSize || (exports.ReviewBoxFontSize = {}));
var ReviewBoxType;
(function (ReviewBoxType) {
    ReviewBoxType["default"] = "default";
    ReviewBoxType["box"] = "box";
})(ReviewBoxType = exports.ReviewBoxType || (exports.ReviewBoxType = {}));
var ReviewBoxStarSize;
(function (ReviewBoxStarSize) {
    ReviewBoxStarSize["small"] = "small";
    ReviewBoxStarSize["default"] = "default";
})(ReviewBoxStarSize = exports.ReviewBoxStarSize || (exports.ReviewBoxStarSize = {}));
var ReviewBoxElement = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var type = _a.type;
    switch (type) {
        case ReviewBoxType.box:
            return "\n          border: 1px solid ".concat(b2c_theme_1.colors.reviewBoxBorder, ";\n          padding: 1rem;\n        ");
        default:
            return "\n          padding: 3.1rem 0 2.1rem;\n        ";
    }
});
var ReviewBoxHeading = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n"])));
var ReviewParagraph = styled_components_1.default.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var fontSize = _a.fontSize;
    switch (fontSize) {
        case ReviewBoxFontSize.small:
            return "\n          font-size: 1.4rem;\n          line-height: 2.2rem;\n        ";
        default:
            return "\n          font-size: 1.5rem;\n          line-height: 2.4rem;\n        ";
    }
});
var ReviewSubtext = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n\n  opacity: 0.6;\n"], ["\n  ", ";\n\n  opacity: 0.6;\n"])), function (_a) {
    var fontSize = _a.fontSize;
    switch (fontSize) {
        case ReviewBoxFontSize.small:
            return "\n          font-size: 1rem;\n          line-height: 1.8rem;\n          font-weight: 500;\n          text-transform: uppercase;\n        ";
        default:
            return "\n          font-size: 1.5rem;\n          line-height: 2.4rem;\n          color: ".concat(b2c_theme_1.colors.primaryLightFontColor, ";\n          font-weight: 400;\n        ");
    }
});
var ReviewBox = function (props) {
    var defaultProps = {
        secondaryText: [],
        starSize: ReviewBoxStarSize.default,
    };
    var _a = __assign(__assign({}, defaultProps), props), rating = _a.rating, reviewText = _a.reviewText, verifiedLabelText = _a.verifiedLabelText, showVerifiedLabel = _a.showVerifiedLabel, secondaryText = _a.secondaryText, starSize = _a.starSize, reviewBoxType = _a.reviewBoxType, rest = __rest(_a, ["rating", "reviewText", "verifiedLabelText", "showVerifiedLabel", "secondaryText", "starSize", "reviewBoxType"]);
    return (react_1.default.createElement(ReviewBoxElement, __assign({ "data-testid": "review-box", type: reviewBoxType || ReviewBoxType.default }, rest),
        react_1.default.createElement(ReviewBoxHeading, { "data-testid": "review-box-heading" },
            react_1.default.createElement(StarRatingGroup_1.default, { activeStars: rating, iconSize: starSize === 'small' ? b2c_theme_1.IconSizes.xSmall : b2c_theme_1.IconSizes.small, iconSpacing: starSize === 'small'
                    ? Star_1.IconSpacingSizes.small
                    : Star_1.IconSpacingSizes.large, includeRatingCount: false }),
            showVerifiedLabel && verifiedLabelText && (react_1.default.createElement(VerifiedReviewLabel_1.default, { text: verifiedLabelText, fontSize: reviewBoxType === ReviewBoxType.box
                    ? VerifiedReviewLabel_1.VerifiedReviewLabelFontSize.small
                    : VerifiedReviewLabel_1.VerifiedReviewLabelFontSize.default }))),
        react_1.default.createElement(ReviewParagraph, { "data-testid": "review-box-paragraph", fontSize: reviewBoxType === ReviewBoxType.box
                ? ReviewBoxFontSize.small
                : ReviewBoxFontSize.default }, reviewText),
        secondaryText.map(function (secText, index) { return (react_1.default.createElement(ReviewSubtext, { "data-testid": "review-box-subtext-".concat(index), fontSize: reviewBoxType === ReviewBoxType.box
                ? ReviewBoxFontSize.small
                : ReviewBoxFontSize.default, key: secText.replace(/[\W_]+/g, '') }, secText)); })));
};
exports.default = ReviewBox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=ReviewBox.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/ReviewBox/ReviewBox.js
// module id = 1763
// module chunks = 5 16 19